import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import {
  Bell,
  CreditCard,
  Download,
  History,
  ShieldCheck,
  UserRound,
} from "lucide-react";
import { AppFooter } from "../components/AppFooter";

export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
});

const TABS = [
  { to: "/settings/profile", label: "Profile", icon: UserRound },
  { to: "/settings/billing", label: "Plan & billing", icon: CreditCard },
  { to: "/settings/usage", label: "Usage", icon: History },
  { to: "/settings/notifications", label: "Notifications", icon: Bell },
  { to: "/settings/downloads", label: "Downloads", icon: Download },
  { to: "/settings/security", label: "Security", icon: ShieldCheck },
] as const;

/**
 * Settings shell: one page per tab, so no section has to share a scroll with
 * the others. Tabs run down the side on large screens and scroll sideways on
 * phones.
 */
function SettingsLayout() {
  return (
    <div className="flex flex-1 flex-col">
      <div className="mx-auto w-full max-w-5xl flex-1 px-4 py-6 sm:px-6 sm:py-10 lg:px-8">
        <h1 className="text-3xl text-ink">Settings</h1>

        <div className="mt-5 grid gap-6 sm:mt-8 lg:grid-cols-[190px_minmax(0,1fr)] lg:gap-10">
          <nav
            aria-label="Settings sections"
            className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 lg:sticky lg:top-8 lg:mx-0 lg:h-fit lg:flex-col lg:gap-1 lg:overflow-visible lg:px-0 lg:pb-0"
          >
            {TABS.map(({ to, label, icon: Icon }) => (
              <Link
                key={to}
                to={to}
                className="inline-flex shrink-0 items-center gap-2 rounded-full border-2 border-line bg-surface px-3 py-1.5 text-sm font-bold text-ink-soft hover:text-ink lg:rounded-xl lg:border-transparent lg:bg-transparent lg:py-2 lg:hover:border-line lg:hover:bg-surface"
                activeProps={{
                  "aria-current": "page",
                  className:
                    "border-ink! bg-ink! text-white! lg:border-line-strong! lg:bg-surface! lg:text-ink!",
                }}
              >
                <Icon className="size-4" aria-hidden="true" />
                {label}
              </Link>
            ))}
          </nav>

          <div className="min-w-0">
            <Outlet />
          </div>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
